import { atom, SetStateAction } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { RESET } from 'jotai/utils';
import {
  PeriodType,
  PeriodTypeValue,
} from 'src/common/components/PeriodTypeSwitch/PeriodTypeSwitch';

const INITIAL_RSIM_GRAPH_ACCOUNT_VALUE = {
  account: null,
  periodType: PeriodType.TwoDays,
};

type RSIMGraphAtomValue = { account: string | null; periodType: PeriodTypeValue };

export const initialRsimGraphAtom = atom<RSIMGraphAtomValue>(INITIAL_RSIM_GRAPH_ACCOUNT_VALUE);

export const rsimGraphAtom = atom(
  (get) => get(initialRsimGraphAtom),
  (_get, set, newValue: SetStateAction<RSIMGraphAtomValue> | typeof RESET) => {
    if (newValue === RESET) {
      return set(initialRsimGraphAtom, INITIAL_RSIM_GRAPH_ACCOUNT_VALUE);
    }

    return set(initialRsimGraphAtom, newValue);
  },
);

export const rsimGraphPeriodTypeAtom = focusAtom(rsimGraphAtom, (optic) =>
  optic.prop('periodType'),
);
